import './Tile.css';

export interface TileProps {
    num: number;
}

function Tile(props: TileProps) {
    if (props.num === 0) {
        return <div className="col tile">&nbsp;</div>;
    }

    let classes = "col tile";
    if (props.num >= 0 && props.num <= 15) {
        classes += " tile-" + props.num;
    }

    const numStr = "==" + props.num + "==";
    return <div className={classes}>{numStr}</div>;
}

export default Tile;